import ShowcasingsList from "./ShowcasingsList";

export default ShowcasingsList;